import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Grid } from '@mui/material'
import { EmojiEvents } from '@mui/icons-material'
import { useGET_studentAssignmentsQuery } from 'redux/api/assignmentsApi'
import BoxTitle from 'components/atoms/BoxTitle'
import { useTableModel } from 'utils/tableModels/useStudentNeedsDashboardTableModel'
import Table from './../dashboard/Table'
import targetImage from 'assets/images/target.png'

const WhatINeed: FC = () => {
  const { t } = useTranslation()

  const data = [
    {
      subject: 'Mathematics',
      avg: '90%',
      target: 'A'
    },
    {
      subject: 'English',
      avg: '95%',
      target: 'A-'
    },
  ]


  return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <BoxTitle title={t('dashboard.what-do-i-need')} icon={<EmojiEvents />} />
        </Grid>
        <Grid item xs={12}>
           <img src={targetImage} style={{ width: '100%', marginBottom: '10px' }} />
          <Table useTableModel={useTableModel} data={data} rowColor={'#d9eebf'} />
        </Grid>
      </Grid>
  )
}

export default WhatINeed
